export default __webpack_public_path__ + "static/media/Mario.6e7d04c4.JPG";